module.exports = __webpack_public_path__ + "static/media/map-placeholder.6821b67f.png";